import { FolderFilledIcon, PlusIcon } from '@/components/Icons';
import useMoveTrackToFolderDialog from '@/hooks/useMoveTrackToFolderDialog';
import { useRefreshData } from '@/hooks/useRefreshData';
import React from 'react';
import { Button } from '..';
import { DeleteAudioToFolder } from '@/service/folder';

export const Sorting = ({
  folderName,
  id,
}: {
  folderName?: string;
  id: string;
}) => {
  const moveTrackToFolder = useMoveTrackToFolderDialog({ id });
  const { refreshAudioInList, refreshFolders, refreshSongDetail } =
    useRefreshData();
  return (
    <div className="px-[8px]  mt-[16px] w-fit ml-[8px]">
      <div className=" text-jen-size-heading-07 text-jen-content-tertiary">
        SORTING
      </div>
      {folderName ? (
        <Button
          icon={<FolderFilledIcon />}
          className=" mt-jen-spacing-8 h-[32px] "
          text={folderName}
          onClose={async () => {
            await DeleteAudioToFolder({ audioId: id });
            refreshAudioInList({ id });
            refreshFolders();
            refreshSongDetail();
          }}
        />
      ) : (
        <Button
          icon={<PlusIcon fillColor="currentColor" />}
          className=" mt-jen-spacing-8 h-[32px] "
          text={'ADD TO FOLDER'}
          onClick={() => {
            moveTrackToFolder();
          }}
        />
      )}
    </div>
  );
};
